<div class="modeless-content" insResizable [resizeEdges]="resizeEdges" [ngClass]="position.toCssClass()"
     [ngStyle]="calculatedStyle()">
  <ng-content></ng-content>
</div>
